import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getTokenForBrightspeedAPI } from "../../../../shared/hooks/useFetchLogin";
import API_URLS from "../../Utils/axr";
import { errorConditionGTM } from "../../Utils/googleTags";
import DwLogutil from "../../Utils/DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import { RootState } from "../store";
import { PURGE } from "redux-persist";

type brightspeedAPITokenInitialStateType = {
  data: any;
  loading: boolean;
  error: any;
  headers: any;
};
const initialState: brightspeedAPITokenInitialStateType = {
  data: null,
  loading: false,
  error: null,
  headers: {
    brspdChId: "web-acm",
    channel: "web-acm",
    sessionId: sessionStorage?.getItem("sessionId") || "",
    siteId: localStorage.getItem("headersSiteId") || "",
    billingType: null,
    networkType: null,
    billingSystem: null,
    flowType: null,
    nonAuthFlowType: null,
    Authorization: null,
    uniqueId: null,
    acode: null,
    cid: null,
  },
};

export const getBrightspeedToken = createAsyncThunk<any, string | void, { state: RootState }>(
  "brightspeedAPI/token",
  async (flow, { getState }) => {
    const state = getState();
    const existingToken = state?.brightspeedToken?.data;
    if (existingToken) {
      return existingToken;
    }
    try {
      const params = {
        "": [API_URLS?.brightspeedGetTokenAPI],
      };
      const headers = {};
      const response = await getTokenForBrightspeedAPI(params, {}, {
        ...headers,
        ...(flow && { flowType: flow }),
      });
      if (response?.data?.expires_in) {
        const time = new Date();
        time.setSeconds(
          time.getSeconds() + (parseInt(response.data.expires_in) - 99)
        );
      
        response.data.expires_in = time;
      }
      if (response?.data?.id) {
        response.data.access_token = response?.data?.id;
        DwLogutil({stepName: EC_DW_LOGGING_STEPS?.digital_id_api_success});
      }
      return response.data;
    } catch (error) {
      DwLogutil({stepName: EC_DW_LOGGING_STEPS?.digital_id_api_failed, error: error});
      throw error;
    }
  }
);

const brightspeedTokenSlice = createSlice({
  name: "brightspeed/token",
  initialState,
  reducers: {
    resetHeaders: (state) => {
      return initialState;
    },
    resetToken: (state) => {
      state.data = null;
    },
    setHeaders: (state, action: PayloadAction<any>) => {
      state.headers = action.payload;
    },
    updateHeaders: (state, action: PayloadAction<any>) => {
      state.headers = {
        ...state.headers,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBrightspeedToken.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBrightspeedToken.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      if (action.payload?.access_token) {
        state.headers.Authorization = `Bearer ${action.payload.access_token}`;
      }
    });
    builder.addCase(getBrightspeedToken.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "get token APi failed",
        action.error?.message,
        action?.type
      );
      state.data = null;
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(PURGE, () => {
          return  initialState;
     });
  },
});

export const { setHeaders, resetHeaders, updateHeaders, resetToken } =
  brightspeedTokenSlice.actions;
export default brightspeedTokenSlice.reducer;